module.exports = __webpack_public_path__ + "img/favicon_white_cut.10d6f109.svg";